import React from 'react';
import { classes } from 'typestyle';
import { NOT_APPLICABLE_TEXT } from '../../../constants';
import { CountryProfile } from '../../../types';
import { Cell, Grid } from '../../layout/grid/grid.component';
import {
    donutsBlueSmallLabel01ClassName,
    donutsBlueSmallLabel02ClassName,
    donutsGreenSmallLabel01ClassName,
    donutsGreenSmallLabel02ClassName,
    donutsSmallLabelClassName,
    donutsWrapperClassName
} from './target-and-representation-donuts.style';
import { ThemeName } from '../../../types';
import Donut2 from '../../layout/donut-2/donut.component';

interface CountryProfileDonutsProps {
    countryProfile: CountryProfile,
    theme?: ThemeName
}

const TargetAndRepresentationDonuts: React.FC<CountryProfileDonutsProps> = ({
    countryProfile,
    theme = 'blue'
}) => {
    const donutSmallLabel = (
        bigText: string,
        smallText: string,
        extraClassName: string
    ) => (
        <div className={ classes(donutsSmallLabelClassName, extraClassName) }>
            <span>{ bigText }</span>
            <span>{ smallText }</span>
        </div>
    );
    let donutsSmallLabel01ClassName: string;
    let donutsSmallLabel02ClassName: string;

    switch (theme) {
        case 'blue':
            donutsSmallLabel01ClassName = donutsBlueSmallLabel01ClassName;
            donutsSmallLabel02ClassName = donutsBlueSmallLabel02ClassName;
            break;
    
        case 'green':
            donutsSmallLabel01ClassName = donutsGreenSmallLabel01ClassName;
            donutsSmallLabel02ClassName = donutsGreenSmallLabel02ClassName;
            break;
    }

    return (
        <Grid>
            <Cell size={ 12 } sizeTablet={ 6 }>
                <div className={ donutsWrapperClassName }>
                    <Donut2
                        valueSet={ {
                            maxValue: 100,
                            values: [countryProfile.quotaTarget],
                            theme: theme === 'blue' ? 'altBlue' : 'altGreen'
                        } }>
                        { donutSmallLabel(
                            `${Math.round(countryProfile.quotaTarget)}%`,
                            'Quota target',
                            donutsSmallLabel01ClassName
                        ) }
                    </Donut2>
                </div>
            </Cell>
            <Cell size={ 12 } sizeTablet={ 6 }>
                <div className={ donutsWrapperClassName }>
                    <Donut2
                        valueSet={ {
                            maxValue: 100,
                            values: [countryProfile.womensRepresentation || 0],
                            theme: theme === 'blue' ? 'altBlue2' : 'altGreen2'
                        } }>
                        { donutSmallLabel(
                            (
                                countryProfile.womensRepresentation === null
                                ? NOT_APPLICABLE_TEXT
                                : `${Math.round(countryProfile.womensRepresentation)}%`
                            ),
                            'Women\'s representation',
                            donutsSmallLabel02ClassName
                        ) }
                    </Donut2>
                </div>
            </Cell>
        </Grid>
    );
};

export default TargetAndRepresentationDonuts;
